import * as Yup from 'yup';

const GerDepartamentosCadastroSchema = Yup.object({
    descricao: Yup.string().required({ name: 'nomeDepartamento', err: "'NOME DA UNIDADE DE NEGÓCIO' é um campo obrigatório" }),
    responsaveis: Yup.array().required().min(1, { name: 'responsaveis', err: 'É necessário informar pelo menos um Responsável' }),
    // membros: Yup.array().required().min(1, { name: 'membros', err: 'É necessário informar pelo menos um Membro' })
});

export default GerDepartamentosCadastroSchema;